import PropTypes from 'prop-types';
import { useEffect } from 'react';
import Helmet from 'react-helmet';

import { TooltipProvider } from 'twyne-new.ui';

import { useGlobalAuthStore } from '@Stores/global/auth';
import appStore from 'stores/app';
import history from 'utils/history';

import { AppAlertProvider } from './AppAlert'
import MainNav from './MainNav';
import AppRefreshAlertModal from './app-layout/AppRefreshAlertModal';
import AppFooter from './app-layout/Footer';

function Authenticated({ children }) {
  const { auth: { getCurrentSession } } = useGlobalAuthStore()
  useEffect(() => {
    async function verfifyToken() {
      try {
        await getCurrentSession()
        if (!appStore.site) {
          history.push('/auth/site_selection');
        }
      } catch (error) {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          history.push('/auth');
        }
      }
    }
    verfifyToken()
  }, [getCurrentSession])

  return <>
    <AppAlertProvider>
      <TooltipProvider delayDuration={0}>
        <AppRefreshAlertModal />
        <Helmet
          title='Home'
          titleTemplate='%s | Path Evolution'
          meta={[
            { 'char-set': 'utf-8' },
            { name: 'description', content: 'Path Evolution' },
          ]} />
        <AppFooter>
          <MainNav />
          {children}
        </AppFooter>
      </TooltipProvider>
    </AppAlertProvider>
  </>
}

Authenticated.propTypes = {
  children: PropTypes.node,
}

export default Authenticated;
